import React, { useEffect, useState } from 'react'
import { Col, Row, FormGroup, Alert, Input } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'
import Switch from 'react-switch'

const BSCornMasaFlourPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    Size: item.Size,
    Organic: item.Organic,
  })
  const methods = useFormContext()
  const { onChangeReviewer, setSwitchReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const { Size, Organic } = item
      setPackaging({
        Size,
        Organic,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <>
      <Row>
        <Col xs={6}>
          <FormGroup>
            <p>
              <strong>Size {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="Size"
              type="number"
              step="0.01"
              placeholder={'12 - 48 ounces'}
              defaultValue={packaging.Size}
              onKeyDown={e => {
                if (isNotNumericDecimal(e.key)) {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 5,
                  message: '⚠ Size exceeds 5 characters.',
                },
                min: {
                  value: 12,
                  message: '⚠ Size is below the required 12 ounce minimum.',
                },
                max: {
                  value: 48,
                  message: '⚠ Size exceeds the 48 ounces allowed.',
                },
                required: {
                  value: true,
                  message: '⚠ Please enter product size.',
                },
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message: '⚠ Maximum two decimal places allowed.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="Size"
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
        <Col xs={6}>
          <FormGroup>
            <p>
              <strong>Organic</strong>
            </p>
            <Controller
              as={Switch}
              name="Organic"
              id="Organic"
              control={methods.control}
              defaultValue={item.Organic}
              onChange={([checked, event, id]) => {
                setSwitchReviewer(item, checked, event, id)
                return checked
              }}
              disabled={isDisabled}
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  )
}

BSCornMasaFlourPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default BSCornMasaFlourPackageReview
